var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "items" }, [
    _c("h1", [_vm._v("Add Item")]),
    _vm._v(" "),
    _c("div", { staticClass: "form" }, [
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.orderID,
              expression: "orderID"
            }
          ],
          attrs: { type: "text", name: "orderID", placeholder: "Order ID" },
          domProps: { value: _vm.orderID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.orderID = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.typeID,
              expression: "typeID"
            }
          ],
          attrs: { type: "text", name: "typeID", placeholder: "Type ID" },
          domProps: { value: _vm.typeID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.typeID = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.groupID,
              expression: "groupID"
            }
          ],
          attrs: { type: "text", name: "groupID", placeholder: "Group ID" },
          domProps: { value: _vm.groupID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.groupID = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.fabricID,
              expression: "fabricID"
            }
          ],
          attrs: { type: "text", name: "fabricID", placeholder: "Fabric ID" },
          domProps: { value: _vm.fabricID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.fabricID = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.colourID,
              expression: "colourID"
            }
          ],
          attrs: { type: "text", name: "colourID", placeholder: "Colour ID" },
          domProps: { value: _vm.colourID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.colourID = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.name,
              expression: "name"
            }
          ],
          attrs: { type: "text", name: "name", placeholder: "Name" },
          domProps: { value: _vm.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.name = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.width,
              expression: "width"
            }
          ],
          attrs: { type: "text", name: "width", placeholder: "Width" },
          domProps: { value: _vm.width },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.width = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drop,
              expression: "drop"
            }
          ],
          attrs: { type: "text", name: "drop", placeholder: "Drop" },
          domProps: { value: _vm.drop },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.drop = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.total,
              expression: "total"
            }
          ],
          attrs: { type: "text", name: "total", placeholder: "Total" },
          domProps: { value: _vm.total },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.total = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.notes,
              expression: "notes"
            }
          ],
          attrs: { name: "notes", placeholder: "Notes" },
          domProps: { value: _vm.notes },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.notes = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.variations,
              expression: "variations"
            }
          ],
          attrs: { name: "variations", placeholder: "Variations" },
          domProps: { value: _vm.variations },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.variations = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          { staticClass: "app_item_btn", on: { click: _vm.addItem } },
          [_vm._v("Add")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23453784", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23453784","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/NewItem.vue
// module id = null
// module chunks = 